import React from 'react';
import styled from 'styled-components';
import arrow_icon from '../../images/arrow_icon.png';
import { Link, useHistory } from 'react-router-dom';

export default function TitleTopbarBack(props) {
  const history = useHistory();

  // const goBack = () =>{
  //     history.goBack();
  // }
  return (
    <Top_inner style={{ borderBottom: props.borderbottom }}>
      <Back
        onClick={() => {
          props.setShowModal(true);
        }}
      >
        <img src={arrow_icon}></img>
      </Back>
      <Title>{props.title}</Title>

      <Finish
        onClick={() => {
          props.finishClick();
        }}
      >
        {' '}
        완료{' '}
      </Finish>
    </Top_inner>
  );
}

const Top_inner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 200;
  width: 100%;
  height: calc(100vw * (51 / 375));
  display: felx;
  align-items: center;
  padding: 0 calc(100vw * (17 / 375));
`;
const Title = styled.h1`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  letter-spacing: 0.32px;
  // margin-left: calc(100vw*(131.2/375));
`;

const Back = styled.a`
  display: block;
  width: calc(100vw * (9.8 / 375));
  height: calc(100vw * (16 / 375));
`;
const Finish = styled.a`
  display: block;
  font-size: calc(100vw * (16 / 375));
  font-weight: 600;
  line-height: 2.83;
  color: #ffc036;
  margin-left: calc(100vw * (-38 / 375));
`;
